import { useState, useEffect } from 'react';
import { appointmentsService } from '../services/api';
import { AppointmentModal } from '../components/AppointmentModal';
import { formatApptTime, formatApptDateLong } from '../utils/dateFormatters';
import './Dashboard.css';

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modal, setModal] = useState(null);

  async function load() {
    setLoading(true);
    const res = await appointmentsService.getDashboard();
    if (res.success) setData(res.dashboard);
    else setError(res.error);
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  async function confirm(id) {
    await appointmentsService.updateStatus(id, 'confirmed');
    load();
  }

  if (loading) return <div className="dashboard-loading"><div className="loading-spinner"></div><p>Loading…</p></div>;
  if (error) return <div className="dashboard-error"><p>{error}</p><button onClick={load} className="btn btn-primary">Retry</button></div>;

  const { today = [], upcoming = [], pending = [], stats = {} } = data || {};

  const Item = ({ a, showDate, action }) => (
    <div className="job-card" onClick={() => setModal({ appointment: a })} style={{ cursor: 'pointer' }}>
      <div className="job-time">{showDate ? formatApptDateLong(a.starts_at) : formatApptTime(a.starts_at)}</div>
      <div className="job-info">
        <h3>{a.service_name || 'Appointment'}</h3>
        <p className="job-customer">{a.client_name || '—'}{a.staff_name ? ` · ${a.staff_name}` : ''}</p>
      </div>
      {action || <span className={`status-badge status-${a.status.replace('_', '-')}`}>{a.status.replace('_', ' ')}</span>}
    </div>
  );

  return (
    <div className="dashboard">
      <div className="page-header">
        <h1 className="page-title">Dashboard</h1>
        <button className="btn btn-primary" onClick={() => setModal({ create: true })}>+ New Appointment</button>
      </div>

      <div className="stats-grid">
        <div className="stat-card"><span className="stat-value">{stats.today || 0}</span><span className="stat-label">Today</span></div>
        <div className="stat-card"><span className="stat-value">{stats.week || 0}</span><span className="stat-label">This Week</span></div>
        <div className="stat-card"><span className="stat-value">{stats.pending || 0}</span><span className="stat-label">Pending Confirmation</span></div>
      </div>

      <div className="dashboard-grid">
        <div className="dashboard-section">
          <div className="section-header"><h2>Today's Appointments</h2><span className="job-count">{today.length}</span></div>
          {today.length === 0 ? <div className="empty-state"><p>Nothing scheduled today</p></div>
            : <div className="job-list">{today.map((a) => <Item key={a.id} a={a} />)}</div>}
        </div>

        <div className="dashboard-section">
          <div className="section-header"><h2>Upcoming This Week</h2><span className="job-count">{upcoming.length}</span></div>
          {upcoming.length === 0 ? <div className="empty-state"><p>No upcoming appointments</p></div>
            : <div className="job-list">{upcoming.slice(0, 6).map((a) => <Item key={a.id} a={a} showDate />)}</div>}
        </div>

        <div className="dashboard-section attention-section">
          <div className="section-header"><h2>Pending Confirmation</h2><span className="job-count warning">{pending.length}</span></div>
          {pending.length === 0 ? <div className="empty-state success"><p>All caught up!</p></div>
            : <div className="job-list">{pending.map((a) => (
                <Item key={a.id} a={a} showDate action={
                  <button className="btn btn-sm btn-primary" onClick={(e) => { e.stopPropagation(); confirm(a.id); }}>Confirm</button>
                } />
              ))}</div>}
        </div>
      </div>

      <AppointmentModal
        isOpen={!!modal}
        onClose={() => setModal(null)}
        onSave={() => { setModal(null); load(); }}
        appointment={modal?.appointment || null}
      />
    </div>
  );
}
